/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PreloaderIcon = /*#__PURE__*/ createSvgIcon(
  'PreloaderIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.481 1.253a9.66 9.66 0 017.293.076l.008.004a9.58 9.58 0 014.98 12.439l-.004.008a9.55 9.55 0 01-12.452 4.981.5.5 0 01.388-.922 8.55 8.55 0 0011.146-4.455 8.58 8.58 0 00-4.458-11.135A8.66 8.66 0 002.131 6.695a8.93 8.93 0 00.003 6.62.5.5 0 11-.928.37 9.93 9.93 0 010-7.37l.004-.01.004-.009A9.66 9.66 0 016.48 1.253z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default PreloaderIcon;
